import { render, staticRenderFns } from "./ETBZSJNO.vue?vue&type=template&id=12205c44&scoped=true"
import script from "./ETBZSJNO.vue?vue&type=script&lang=js"
export * from "./ETBZSJNO.vue?vue&type=script&lang=js"
import style0 from "./ETBZSJNO.vue?vue&type=style&index=0&id=12205c44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12205c44",
  null
  
)

export default component.exports